import { getGetMeQueryOptions } from '@amarantos/api-client'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { Suspense } from 'react'

import { GenericPageSkeleton } from '@/components/generic-page-skeleton'
import { AppSidebar } from '@/components/sidebar'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'

const STALE_TIME = 5 * 60 * 1000 // 5 minutes

export const Route = createFileRoute('/_authenticated')({
	beforeLoad: async ({ context, location }) => {
		try {
			await context.queryClient.ensureQueryData(
				getGetMeQueryOptions({
					query: { staleTime: STALE_TIME },
				}),
			)
		} catch {
			throw redirect({
				to: '/login',
				search: { redirect: location.href },
			})
		}
	},
	component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
	return (
		<SidebarProvider>
			<AppSidebar />
			<SidebarInset>
				<Suspense fallback={<GenericPageSkeleton />}>
					<Outlet />
				</Suspense>
			</SidebarInset>
		</SidebarProvider>
	)
}
